import {Injectable} from '@angular/core';
import {Observable, Subscriber} from "rxjs";
import {ApiResponse} from "../../api/api-response";
import {HttpClient, HttpContext, HttpContextToken} from "@angular/common/http";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ApiClientService {
  constructor(
    private http: HttpClient
  ) {
  }

  private getContext(options: ApiClientOptions | null): HttpContext {
    let context = new HttpContext();

    if (options?.ignoreBadRequest) {
      context.set(IGNORE_BAD_REQUEST, true);
    }

    return context;
  }

  get(route: string, query: any = {}, options: ApiClientOptions | null = null): Observable<ApiResponse> {
    return new Observable<ApiResponse>((subscriber: Subscriber<ApiResponse>): void => {
      this.http.get(this.getUrl(route, query), {context: this.getContext(options)}).subscribe(this.parseResponse(subscriber));
    })
  }

  post(route: string, query: any = {}, body: any = null, options: ApiClientOptions | null = null): Observable<ApiResponse> {
    return new Observable<ApiResponse>((subscriber: Subscriber<ApiResponse>): void => {
      this.http.post(this.getUrl(route, query), body, {context: this.getContext(options)}).subscribe(this.parseResponse(subscriber));
    });
  }

  put(route: string, query: any = {}, body: any = null, options: ApiClientOptions | null = null): Observable<ApiResponse> {
    return new Observable<ApiResponse>((subscriber: Subscriber<ApiResponse>): void => {
      this.http.put(this.getUrl(route, query), body, {context: this.getContext(options)}).subscribe(this.parseResponse(subscriber));
    });
  }

  delete(route: string, query: any = {}, options: ApiClientOptions | null = null): Observable<ApiResponse> {
    return new Observable<ApiResponse>((subscriber: Subscriber<ApiResponse>): void => {
      this.http.delete(this.getUrl(route, query), {context: this.getContext(options)}).subscribe(this.parseResponse(subscriber));
    });
  }

  private parseResponse(observer: Subscriber<ApiResponse>): object {
    return {
      next: (result: any): void => {
        this.next(observer, result);
      },
      error: (response: any): void => {
        observer.error(response);
        observer.complete();
      }
    };
  }

  private next(observer: Subscriber<ApiResponse>, result: any): void {
    observer.next(new ApiResponse(
      result ? 200 : 204,
      result ? result.success : true,
      result ? result.message : '',
      result ? result.data : null,
      null,
      result ? result.total : null,
    ));
    observer.complete();
  }

  private getUrl(route: string, query: any = {}): string {
    let url = environment.server.url + '/api/gizmo' + route;

    if (query !== null && Object.keys(query).length) {
      url += '?' + new URLSearchParams(query);
    }

    return url;
  }
}

export const IGNORE_BAD_REQUEST = new HttpContextToken<boolean>(() => true);

interface ApiClientOptions {
  ignoreBadRequest: boolean;
}
